<template src= "./genre_index.html"></template>

<script>
import isEmpty from 'lodash/isEmpty'
import { parseISO, format } from 'date-fns'
import optionData from '@/optionData/data'
import {ko} from 'vuejs-datepicker/dist/locale'
import { Tag } from 'element-ui'
import moment from 'moment'
import agTableComp from '@/optionData/agTableComp'

export default {
  name: 'artistList',
  
    data () {
        return {
            ko : ko,
            optionData : optionData,
            //급계약코드(디폴트) / Email ID / 권리자명 / 회사
            keywordOption :[
                
                {value: '_licensor', label:'권리자명 및 회사명'},
            ],
            keywordType : '_licensor',
            keyword : '',

            genreOption : [],
            genre:null,

            startDate :null,
            endDate : null,
            dateType :'created_at' ,
            dateOption : [
                {value: 'created_at',label: '등록일',},
            ],
            total : 0,
            filtered:0,
            page: {
                pageSize : 10,
                currentPage: 1,                       // 현재 페이지
                totalPage: 0,                         // 총 페이지수
            },          
            gridOptions :{ // 테이플 옵션
                onRowClicked: (event)=>{
                    //this.viewDetail(event)
                },
                frameworkComponents : {
                    btnSelect : agTableComp.btnSelect,
                    btnDelete : agTableComp.btnDelete,
                },
                context: {
                    componentParent: this
                },
                getRowHeight:(params)=>{
                    
                    return 80;
                }
            },
            defaultColDef: {
                sortable: false,
                editable: false,
                resizable: true,
                suppressMenu: false,
                rowSelection:'single'
            },
            
            columnDefs: [

                // album_count: 1
                // amount_remaining: 40072232.84693845
                // amount_total: 42906150
                // created_at: "2021-12-13T07:11:07.445Z"
                // end_date: null
                // id: 5
                // licensor_id: 1813
                // ref_code: "AP0005"
                // service_fee: 15
                // start_date: "2021-10-21"
                // updated_at: "2022-01-05T02:44:11.094Z"
                // user_company: "리플라이프로젝트"
                // licensor.currency: "krw"
                // user_email: "reflyproject@soundrepublica.com"
                // user_family_name: "노"
                // user_given_name: "건식"
                // user_name: "노 건식"

                {headerName: '번호', field: 'id', filter: false,width: 100,
                cellRenderer: (data) => {
                    return `<div class="cellCenter"><span>${data.value}</span></div>`
                }},
                
                {headerName: '권리자/회사명',      field: 'licensor',     filter: false,width: 200, cellRenderer: (data) => {
                    let name = `${(data.value.family_name ? data.value.family_name : '')} ${(data.value.given_name ? data.value.given_name : '')}`
                    var pattern3 = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/; //한글
                    if(pattern3.test(name)){
                        name = `${(data.value.family_name ? data.value.family_name : '')} ${(data.value.given_name ? data.value.given_name : '')}`
                    }else{
                        name = `${(data.value.given_name ? data.value.given_name : '')} ${(data.value.family_name ? data.value.family_name : '')}` 
                    }
                    return `<div class="cellCenter"><p>${name}</p><p>${data.value.company}</p></div>`
                }},
                
                {headerName: '장르명',      field: 'genre',     filter: false,width: 330,
                cellRenderer: (data) => {
                    return `<div class="cellCenter"><span>${data.value.name_english}</span></div>`
                }},
                
                
                {headerName: '등록일시',      field: 'created_at',     filter: false,width: 200, cellRenderer: (data) => {
                     return `<div class="cellCenter"><span>${this.fixDate(data.value)}</span></div>`
                }},
                {headerName: '', field: 'id', filter: false,minWidth: 140,
                    cellRendererParams: {
                        clicked: function(data) {
                            this.context.componentParent.deleteBlackList(data.id);
                        },
                        clicked2 : function(data) {
                            
                            this.context.componentParent.deleteBlackList(data.id);
                        }
                    },
                    cellRenderer: 'btnDelete'
                },
            ],
            tableData:[
            ],       
            

            modalStep: 1,
            userTable:{
                defaultColDef: {
                    sortable: false,
                    editable: false,
                    resizable: true,
                    suppressMenu: false,
                    rowSelection:'single'
                },
                gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
                    context: {
                        componentParent: this
                    },
                    onGridReady: function (event) {
                    },
                    frameworkComponents : {
                        btnSelect : agTableComp.btnSelect
                    }
                },
                columnDefs : [
                    {headerName: '선택', field: 'email', filter: false,width: 100,
                        cellRendererParams: {
                        clicked: function(data) {
                            this.context.componentParent.selectLicensorData(data)
                        }
                        },
                        cellRenderer: 'btnSelect'
                    },
                    {headerName: 'E-mail ID', field: 'email', filter: false,width: 250,},
                    {headerName: '권리자명 (성 이름)', field: 'licensor.family_name', filter: false,width: 150,
                        cellRenderer: (data) => {
                        let fm = data.data.licensor.family_name ? data.data.licensor.family_name : '';
                        let gm = data.data.licensor.given_name ? data.data.licensor.given_name : '' ;
                        return fm +' '+ gm
                    }},
                    {headerName: '회사명', field: 'licensor.company', filter: false,width: 150,},
                    
                    {headerName: '정산화폐', field: 'licensor.currency', filter: false,width: 150,
                        cellRenderer: (data) => {
                        const type = {
                            'krw' : 'KRW',
                            'usd' : 'USD',
                            'eur' : 'EUR',
                        }
                        return type[data.value]
                    }},
                    {headerName: '사업자여부', field: 'licensor.entity', filter: false,width: 150, cellRenderer: (data) => {
                        const type = {
                            'individual' : '개인',
                            'corporation' : '사업자',
                        }
                        return type[data.value]
                    }},
                     
                ],
                keywordType : {label:'회사명', value:'company'},
                keywordTypeOption : optionData.memberKeyword,
                keyword : 'Independent Digital',
                
                listData: [],                 
                pageSize: 5,                 
                currentPage: 1,
                totalPage: 0,       
            },
            selectData : {
                licensor : null,
                value : null
            },
            
        }
    },
    created(){
        if(this.$route.query.page){
            this.page.currentPage= Number(this.$route.query.page)
        }
        if(this.$route.query.keywordType){
            this.keywordType= this.$route.query.keywordType
        }
        if(this.$route.query.keyword){
            this.keyword= this.$route.query.keyword
        }
        if(this.$route.query.genre){
            this.genre= this.$route.query.genre
        }
        
        if(this.$route.query['date_field']) this.dateType = this.$route.query['date_field'] 
        if(this.$route.query['date_start'] && this.$route.query['date_end'] ) {
            this.startDate = this.$route.query['date_start'] 
            this.endDate = this.$route.query['date_end'] 
        }
    },
    mounted(){
        this.$nextTick(() =>{
            this.callList()
            this.getGenreList()
        })
    },
    watch: {
        'page.currentPage'(e){
            
            this.callList()
        },
        'page.pageSize'(){
            this.list_search()
        },
        'userTable.currentPage'(){
            this.getUserList()
        },
    },
    methods: {
        resetSearch (){
            this.page.currentPage = 1
            this.keywordType = null
            this.keyword = ''
            this.dateType = null
            this.startDate = null
            this.endDate = null
            this.callList() 
        },
        callList(){
            const option = {
                sort : 'id',
                sortorder: 'desc',
                page: this.page.currentPage-1 ,
                limit: this.page.pageSize,
            }
            let query = {
                
            }
            if(this.page.currentPage != 1){
                query['page'] = this.page.currentPage
            }
            if(this.keywordType && this.keyword != '') {
                option[this.keywordType] = this.keyword
                query['keywordType'] = this.keywordType
                query['keyword'] = this.keyword 
            }
            if(this.genre){
                
                option['genre_id'] = this.genre
                query['genre'] = this.genre
                
            }
            if( !this.valCheck(this.startDate ) && !this.valCheck(this.endDate) ){
                //option['date_field'] = this.dateType
                option['date_start'] = this.startDate
                option['date_end'] = this.endDate
                // if(this.dateType !== 'registered_at' ){
                //     option['sort'] = this.dateType +',registered_at'
                // }else{
                //     option['sort'] = this.dateType
                // }
                
                //query['date_field'] = this.dateType
                query['date_start'] = this.startDate
                query['date_end'] = this.endDate
            }else{
                delete option['date_start'] 
                delete option['date_end'] 
                delete query.date_start
                delete query.date_end
            }
            this.$router.replace({query: query}).catch((e)=>{});
            this.loadingShow()
            this.$store.dispatch('GET_BLACKLIST_GENRE', option)
            .then(result =>{
                this.loadingHide()
                console.log(result)
                this.tableData  = result.items // 권리자 목록
                
                this.total = result.total // 총인원수 
                this.filtered = result.filtered // limit에 따른 수
                //페이지 수
                const remainder = parseInt(this.filtered % this.page.pageSize) > 0? 1: 0
                this.page.totalPage = parseInt(this.filtered/this.page.pageSize) + remainder
            }).catch(error=>{
                this.loadingHide()
                const status = error.status
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                    this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        deleteBlackList(data){
            const option = {
                id : data,
            }
            this.confirm({
                title : '삭제 확인',
                msg: '선택하신 블랙리스트를 삭제하시겠습니까?',
                autofocus:true,
                action : ()=>{
                    this.$store.dispatch('DELETE_BLACKLIST_GENRE', option)
                    .then(result =>{
                        this.loadingHide()
                        this.callList()
                        
                    }).catch(error=>{ 
                    })
                }
            })
           
        },
        openAddModal(){
            this.openModal('modal')
            this.selectData.value = null
            this.selectData.licensor = null
            this.modalStep =1
            this.getUserList()
           
        },
        getUserList(){
            const option = {
            sort: 'created_at',
            sortorder: 'desc',
            role : 'licensor',
            page: this.userTable.currentPage-1 ,
            limit: this.userTable.pageSize
            }
            if(this.userTable.keywordType && this.userTable.keywordType !='') {
                option[this.userTable.keywordType.value] = this.userTable.keyword
            }
            this.loadingShow()
            this.$store.dispatch('GETUSER', option)
            .then(result =>{
                this.userTable.listData  = result.items // 권리자 목록
                const remainder = parseInt(result.filtered % this.userTable.pageSize) > 0? 1: 0
                this.userTable.totalPage = parseInt(result.filtered /this.userTable.pageSize) + remainder
                this.loadingHide()
            }).catch(error=>{
                this.loadingHide()
                const status = error.response.status
                switch(status){
                case 401:
                this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                break;
                default:
                break;
                }
            })
        },
        selectLicensorData(data){
            console.log(data);
            this.selectData['licensor'] = data
            this.modalStep = 2
        },
        addBlackList(){
            const option = {
                params:{
                    "licensor_id": this.selectData.licensor.licensor.id,
                    "genre_id": this.selectData.value
                }
            }
            if(this.valCheck(this.selectData.value)){
                this.alert({msg:'BlackList에 추가할 값을 입력해주세요.'})
            }
             
            this.loadingShow()
            this.$store.dispatch('POST_BLACKLIST_GENRE', option)
            .then(result =>{
                
                this.closeModal('modal')
                this.loadingHide()
                this.callList()
            }).catch(error=>{
                this.loadingHide()
                const status = error.status
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                    this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        list_search(){
            this.page.currentPage = 1  // 초기화
            this.callList()
        },
        viewDetail(event){
            this.$router.push('blacklist/label/detail/'+event)
        },
        getGenreList(){
            this.$store.dispatch('GET_GENRE')
            .then(result =>{
                this.genreOption  = result.items // 권리자 목록
            }).catch(error=>{
                const status = error.response.status
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                    break;
                }
            })
        },
    }
}
</script>

<style scoped>

</style>
